import { IOperationAllow, canOperate } from '../common';
import { filter as lfilter } from 'lodash/fp';

export const labels = (operations: IOperationAllow[]) =>
  lfilter<{ label: string; value: number; allow: boolean }>({ allow: true })([
    {
      label: 'Member Approvals',
      value: 0,
      allow: canOperate(operations)('approve'),
    },
    {
      label: 'Member Revocations',
      value: 1,
      allow: canOperate(operations)('approve'),
    },
    {
      label: 'Status of Requests',
      value: 2,
      allow: canOperate(operations)('approve'),
    },
    {
      label: 'Search Users',
      value: 3,
      allow: canOperate(operations)('approve'),
    },
  ]);
